export const THEME_KEY_VERSION = 'version'
export const THEME_VERSION_V2 = 'v2'
